import * as React from 'react';
import { Responsive } from '@cian/ui-kit/responsive';

import { SectionOfQuestions as SectionOfQuestionsDesktop } from './views/Desktop';
import { SectionOfQuestions as SectionOfQuestionsMobile } from './views/Mobile';

export const SectionOfQuestions = () => {
  return (
    <>
      <Responsive desktop>
        <SectionOfQuestionsDesktop />
      </Responsive>

      <Responsive tablet phone>
        <SectionOfQuestionsMobile />
      </Responsive>
    </>
  );
};
